import { Card } from "$root/components/EvolvedPrint/components/Card";
import { commonReportColumns } from "$root/components/EvolvedPrint/components/table/common-report-columns";
import type { PrintableProps } from "$root/components/EvolvedPrint/configuration/types";
import type { BondDividendRow } from "$root/widgets-architecture/widgets/BondsDividendsTracker/data";
import { type TableColumn, BaseTable } from "@mdotm/shadcn/legacy/components";

type BondsDividendsColumn = Omit<TableColumn<BondDividendRow>, "width"> & { width: number };

const columns: BondsDividendsColumn[] = [
	{ ...commonReportColumns.date<BondDividendRow>("date", "Date"), width: 96, maxWidth: 96 },
	{
		...commonReportColumns.string<BondDividendRow>("name", "Name"),
		minWidth: 160,
		width: 160,
		headerCellStyle: { flexGrow: 1 },
		cellStyle: { flexGrow: 1 },
	},
	{ ...commonReportColumns.string<BondDividendRow>("type", "Type"), width: 96, maxWidth: 96 },
	{ ...commonReportColumns.percentage<BondDividendRow>("couponRate", "Rate / Yield"), width: 90, maxWidth: 90 },
	{ ...commonReportColumns.percentage<BondDividendRow>("deltaCash", "Delta cash"), width: 90, maxWidth: 90 },
];

const BondsDividendsTracker = ({
	sectionTitle,
	list,
}: PrintableProps<{ sectionTitle: string }, BondDividendRow>): React.JSX.Element => {
	return (
		<Card title={sectionTitle}>
			<BaseTable disableVirtualScroll palette="uniform" columns={columns} rows={list} noDataText="No data available" />
		</Card>
	);
};

export default BondsDividendsTracker;
